// store/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authService } from "../../services/auth.service";


export const loginUser = createAsyncThunk(
	"auth/login",
	async ({ email, password }) => {
		const response = await authService.login(email, password);
		return response;
	}
);

export const registerUser = createAsyncThunk(
	"auth/register",
	async ({ email, password, userData }) => {
		const response = await authService.register(email, password, userData);
		return response;
	}
);

export const logoutUser = createAsyncThunk("auth/logout", async () => {
	await authService.logout();
});

const authSlice = createSlice({
	name: "auth",
	initialState: {
		user: null,
		loading: true,
		error: null,
	},
	reducers: {
		setUser: (state, action) => {
			state.user = action.payload;
            state.loading = false;
		},
		clearUser: (state) => {
			state.user = null;
			state.loading = false;
		},
		setLoading: (state, action) => {
			state.loading = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(loginUser.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(loginUser.fulfilled, (state, action) => {
				state.loading = false;
				state.user = action.payload;
				state.error = null;
			})
			.addCase(loginUser.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message;
			})
			.addCase(registerUser.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(registerUser.fulfilled, (state, action) => {
				state.loading = false;
				state.user = action.payload;
				state.error = null;
			})
			.addCase(registerUser.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message;
			})
			.addCase(logoutUser.fulfilled, (state) => {
				state.user = null;
				state.loading = false;
				state.error = null;
			});
	},
});

export const { setUser, clearUser, setLoading, setError } = authSlice.actions;

export default authSlice.reducer;
